import { useCallback, FC } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Box, Typography, Button } from '@altermaind/web/ui';
import { useDialog } from '@/_shared/hooks';

type Props = {
  text: string;
  onConfirm?: () => void;
};
export const DialogConfirmAction: FC<Props> = ({ text, onConfirm }) => {
  const t = useTranslations('general');
  const { closeDialog, Dialog, isOpen } = useDialog('confirmAction');

  const buttonClickHandler = useCallback(() => {
    onConfirm?.();
  }, [onConfirm]);

  return (
    <Dialog open={isOpen} title={undefined} onClose={closeDialog} closeButton>
      <Box display='flex' mx='l' flexDirection='column' px='s'>
        <Typography variant='p2' color='primary/text' textAlign='center'>
          {text}
        </Typography>
      </Box>

      <Button
        variant='primary'
        onClick={buttonClickHandler}
        mt='l'
        data-testid='confirm-operation-button'
      >
        {t('confirm')}
      </Button>
    </Dialog>
  );
};
